import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "Icon",
  viewBox: "0 0 36 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#a)\" stroke=\"#1F3B35\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M18 19.586a3.964 3.964 0 1 0 0-7.929 3.964 3.964 0 0 0 0 7.929ZM11.229 25.77a7.927 7.927 0 0 1 13.541 0\"></path><path d=\"M18 28.307c5.692 0 10.307-4.614 10.307-10.307 0-5.693-4.615-10.307-10.307-10.307-5.693 0-10.308 4.614-10.308 10.307 0 5.693 4.615 10.307 10.308 10.307Z\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" transform=\"translate(6 6)\" d=\"M0 0h24v24H0z\"></path></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }